import { Component } from '@angular/core';
import { BaseComponentWithDialog } from '../../../admin-panel/base-admin-panel/base-component-with-dialog';

@Component({
    selector: 'app-raw-data',
    templateUrl: './raw-data.component.html',
    styleUrls: ['./raw-data.component.css'],
    standalone: false
})
export class RawDataComponent extends BaseComponentWithDialog {
}
